import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';

function VisitorOutProcess() {
  const [showScannerInput, setShowScannerInput] = useState(false);
  const [barcode, setBarcode] = useState('');

  const handleScanClick = () => {
    setShowScannerInput(true);
  };

  const handleBarcodeSubmit = () => {
    if (!barcode.trim()) {
      alert('Please scan or enter a gate pass code.');
      return;
    }
    console.log('🔍 Barcode scanned:', barcode);
    // TODO: Navigate or call API to search visitor by barcode
  };

  return (
    <>
      <Navbar />

      <style>{`
        .welcome-hero {
          background: radial-gradient(1200px 600px at 20% -10%, #e8f0ff 0%, rgba(232,240,255,0) 70%),
                      radial-gradient(900px 500px at 120% 10%, #e6fff5 0%, rgba(230,255,245,0) 70%);
          border-radius: 1.25rem;
        }
        .emoji-bubble {
          width: 64px; height: 64px; border-radius: 18px;
          display:flex; align-items:center; justify-content:center;
          background:#fff; border:1px solid #edf0f4;
          box-shadow: 0 4px 16px rgba(0,0,0,.06);
          font-size: 30px;
        }
        .dash-card {
          border:1px solid #edf0f4; border-radius: 14px;
        }
      `}</style>

      <div className="container py-4">
        {/* Hero */}
        <div className="welcome-hero p-4 p-md-5 shadow-sm">
          <div className="d-flex align-items-center gap-3 mb-3">
            <div className="emoji-bubble">🚪</div>
            <div>
              <h2 className="mb-1 fw-bold text-primary">Gate Pass — Visitor OUT</h2>
              <div className="text-muted">
                You’re in the <strong>Visitor Out Process</strong>. Use the options below to continue.
              </div>
            </div>
          </div>

          <div className="row g-3 mt-2">
            {/* Checkout List Card */}
            <div className="col-12 col-md-4">
              <div className="dash-card p-3 h-100">
                <div className="text-muted small">Quick Action</div>
                <h5 className="mt-1 mb-3">Proceed to Checkout</h5>
                <p className="text-muted mb-3">
                  See all visitors currently inside and mark them OUT with one click.
                </p>
                <a href="/visitor-out/list" className="btn btn-primary w-100">
                  Open Checkout List
                </a>
                <div className="small text-muted mt-2">
                  (Wire this to the actual list route you’ll use.)
                </div>
              </div>
            </div>

            {/* Scan Card */}
            <div className="col-12 col-md-4">
              <div className="dash-card p-3 h-100">
                <div className="text-muted small">Optional</div>
                <h5 className="mt-1 mb-3">Scan Gate Pass Barcode</h5>
                <p className="text-muted mb-3">
                  Jump straight to a specific visitor by scanning their gate pass code.
                </p>

                {!showScannerInput ? (
                  <button
                    className="btn btn-outline-secondary w-100"
                    onClick={handleScanClick}
                  >
                    Scan
                  </button>
                ) : (
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Scan or enter code..."
                      value={barcode}
                      onChange={(e) => setBarcode(e.target.value)}
                      autoFocus
                    />
                    <button
                      className="btn btn-primary"
                      onClick={handleBarcodeSubmit}
                    >
                      Go
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Tips Card */}
            <div className="col-12 col-md-4">
              <div className="dash-card p-3 h-100">
                <div className="text-muted small">Tips</div>
                <h5 className="mt-1 mb-3">Best Practices</h5>
                <ul className="text-muted mb-0">
                  <li>Verify ID and items before OUT.</li>
                  <li>Confirm laptops/tools returned.</li>
                  <li>Add short remark if needed.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VisitorOutProcess;
